'use strict';

export const facingDictionary = () => {
    const dictionary = {

            "דרום": {
                "en": "South",
                "ru": "",
                "he": "דרום"
            },

            "צפון": {
                "en": "North",
                "ru": "",
                "he": "צפון"
            },
            "מזרח": {
                "en": "East",
                "ru": "",
                "he": "מזרח"
            },

            "מערב": {
                "en": "West",
                "ru": "",
                "he": "מערב"
            },
        };

    return dictionary;
}

export const dataArrayOfFlat = (object) => {
    const data = [
        {
            name: 'apt. type',
            data: object.modelName,
            icon: 'icon-plan-type',
        },
        {
            name: 'bedrooms',
            data: object.roomNum,
            icon: 'icon-bedroom',
        },
        {
            name: 'area',
            data:  object.totalSpace,
            icon: 'icon-area',
        },
        {
            name: 'exposure',
            data:  object.facing,
            icon: 'icon-exposure',
        },
        {
            name: 'balcony size',
            data:  object.balconySize,
            icon: 'icon-balcony',
        },
        {
            name: 'bathrooms',
            data:  object.bathRooms,
            icon: 'icon-bathroom',
        },
        {
            name: 'garden size',
            data:  object.gardenSize,
            icon: 'icon-default-icon', // no icon
        },
        {
            name: 'toilets',
            data:  object.toilets,
            icon: 'icon-toilet',
        },
        {
            name: 'accessible',
            data:  object.accessible,
            icon: 'icon-disabled',
        },
        {
            name: 'treatmentRoom',
            data:  object.treatmentRoom,
            icon: 'icon-bed',
        },
    ]

    return data;
}

export const createIconsArray = () => {
    const iconArray = [
        {
            type: '360',
            crmTitle: 'tours360',
            // plan: 'https://dreamsimages.bmby.com/mazlavidreams/panocontent/tours/b1/index.htm',  // for testing buttons
            disclaimer: 'Lorem dolores ex recusandae rerum.',
            icon: 'icon-360',
        },
        {
            type: '360Sample',
            crmTitle: 'sample360',
            plan: 'https://dreamsimages.bmby.com/mazlavidreams/panocontent/tours/b1/index.htm',  // for testing buttons
            disclaimer: 'Lorem dolores ex recusandae rerum.',
            icon: 'icon-360',
        },
        {
            type: '2D',
            crmTitle: 'plan2D',
            // plan: 'https://dreamsimages.bmby.com/cnaan/content2d/proj_1.jpg',  // for testing buttons
            // plan: '',  // for testing buttons
            disclaimer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci animi autem delectus deleniti dignissimos, dolores ex exercitationem maxime neque provident, sapiente velit! Architecto eos eum, itaque iure libero recusandae rerum.',
            icon: '',
        },
        {
            type: '3D',
            crmTitle: 'web3D',
            // plan: '',
            icon: '',
        },
        {
            type: 'vantage',
            crmTitle: 'vantage',
            // plan: 'https://dreamsimages.bmby.com/mazlavidreams/panocontent/vantages/vantage101a/index.htm?media-index=1&yaw=0',  // for testing buttons
            icon: 'icon-vantage',
        },
        {
            type: 'gallery',
            crmTitle: 'gallery',
            icon: 'icon-gallery',
        },
        {
            type: 'Ruler',
            crmTitle: '',
            icon: 'icon-ruler',
        },
    ];
    return iconArray;
};
